import React from "react";
import { Link } from "react-router-dom";

function PageHero({ title, subtitle, image }) {
  return (
    <div
      className="hero-section d-flex align-items-center justify-content-center text-white"
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <div className="overlay"></div>

      <div className="text-center position-relative">
        <h1 className="display-4 fw-bold">{title}</h1>
        <p className="mt-2">{subtitle}</p>

        {/* Breadcrumb */}
        <p className="mt-2">
          <Link to="/" className="text-white text-decoration-none">
            Home
          </Link>{" "}
          <span className="mx-2">{">"}</span>
          <span>{title}</span>
        </p>
      </div>
    </div>
  );
}

export default PageHero;